import * as moment from 'moment'
import * as React from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { IMap, IMembershipObject, IProviderProductObject, IServiceObject } from '../../../../types'
import UIMessages from '../../../../utils/ui-messages'
import CollapseIcon from '../../../icons/ui/CollapseIcon'
import ExpandIcon from '../../../icons/ui/ExpandIcon'
import TooltipIcon from '../../../icons/ui/TooltipIcon'
import { MembershipTypes } from 'src/constants/service'

interface IMembershipListItemProps {
  membership: IMembershipObject
  providerProducts: IMap<IProviderProductObject>
  service: IServiceObject
  suspend: (membership: IMembershipObject) => void
}

interface IMembershipListItemState {
  expanded: boolean
  months: string[]
  numberTypes: IDropdownOption[]
}

interface IDropdownOption {
  label: string
  value: string
}

class MembershipListItem extends React.Component<IMembershipListItemProps, IMembershipListItemState> {
  constructor(props: any) {
    super(props)

    this.state = {
      expanded: true,
      months: [
        UIMessages.common.months.januaryShortName,
        UIMessages.common.months.februaryShortName,
        UIMessages.common.months.marchShortName,
        UIMessages.common.months.aprilShortName,
        UIMessages.common.months.mayShortName,
        UIMessages.common.months.juneShortName,
        UIMessages.common.months.julyShortName,
        UIMessages.common.months.augustShortName,
        UIMessages.common.months.septemberShortName,
        UIMessages.common.months.octoberShortName,
        UIMessages.common.months.novemberShortName,
        UIMessages.common.months.decemberShortName
      ],
      numberTypes: [
        { value: 'Unlimited', label: UIMessages.common.unlimited },
        { value: 'Week', label: UIMessages.common.week },
        { value: 'Month', label: UIMessages.common.month },
        { value: 'Year', label: UIMessages.common.year }
      ]
    }
  }

  public render() {
    const { service, membership } = this.props
    if (!service) {
      return null
    }
    return (
      <div className='mt1 mb2'>
        <div className='rounded bg-light-grey3 p1'>
          <div className='flex'>
            {/* TODO: Add tooltip for description */}
            <span>
              <span className='MembershipTitle bold'>{service.name}</span>
            </span>
            <div style={{ flex: 1 }}>
              <span className='ml2'>Membership ID: </span>
              <span className='ml2 font-blue bold'>{membership.externalRiderId || 'None'}</span>
            </div>
            <div className='mr2'>{this.renderEligibility()}</div>
            {this.props.service.providerProducts && this.props.service.providerProducts.length > 0 && (
              <div>
                {!this.state.expanded && (
                  <div style={{ cursor: 'pointer' }} onClick={this.onToggleExpand}>
                    <ExpandIcon className='icon--small svg-stroke-grey3 mr1' />
                  </div>
                )}
                {this.state.expanded && (
                  <div style={{ cursor: 'pointer' }} onClick={this.onToggleExpand}>
                    <CollapseIcon className='icon--small svg-stroke-grey3 mr1' />
                  </div>
                )}
              </div>
            )}
            <div>
              {/* TODO: Fix ContextMenu's style. It's breaking this div */}
              {/*
                 //TODO revert after functionality for suspension is ready
                 <ContextMenu className='ListItemMenu'>
                 <div className='MenuItem flex cursor--pointer'>
                 <div onClick={this.onSuspend}>
                 //TODO: get proper icon for suspend
                 <EditIcon className='icon--small svg-stroke-grey3 mr1'/>
                 <span className='font-dark-grey'>Suspend</span>
                 </div>
                 </div>
                 </ContextMenu>
                 */}
            </div>
          </div>
        </div>
        {this.state.expanded && (
          <div className='mr2 ml2'>
            {this.props.service.providerProducts &&
              this.props.service.providerProducts.map(it => {
                const providerProduct = this.props.providerProducts[it.id]
                if (providerProduct) {
                  return (
                    <div className='mt1 mb1' key={`tmli-${it}`}>
                      {/* TODO: Add Icon URL */}
                      {providerProduct.name}
                      {/* TODO: Add star */}
                    </div>
                  )
                }
                return null
              })}
          </div>
        )}
      </div>
    )
  }

  private onSuspend(param: any) {
    this.props.suspend(this.props.membership)
  }

  private getLimitedDateTime(membership: IMembershipObject) {
    return (
      <span>
        {'From ' +
          moment(membership.beginsAt).format('MMMM DD, YYYY') +
          ' To ' +
          moment(membership.expiresAt).format('MMMM DD, YYYY')}
      </span>
    )
  }

  private getNumberOfRides(membership: IMembershipObject) {
    let by = ' per ' + membership.ridesRangeType
    if (membership.ridesRangeType === 'Unlimited') {
      by = ''
    }
    // TODO: Add amount left to IMembershipObject
    return <span>{membership.ridesNum + ' Rides' + by}</span>
  }

  private getRecurring(membership: IMembershipObject) {
    return <span>{'Recurring (' + membership.recurringMonths.map(s => s).join(', ') + ')'}</span>
  }

  private renderEligibility() {
    const { membership } = this.props
    const membershipType = membership.type.toLowerCase()

    if (membershipType === MembershipTypes.PERMANENT) {
      return <span>Permanent</span>
    } else if (membership.isLimitedByDate) {
      return this.getLimitedDateTime(membership)
    } else if (membership.isLimitedByNumberOfRides) {
      return this.getNumberOfRides(membership)
    } else if (membership.isLimitedByRecurringMonths) {
      return this.getRecurring(membership)
    }

    return <span>Error</span>
  }

  private onToggleExpand = () => {
    this.setState({
      expanded: !this.state.expanded
    })
  }
}

export default MembershipListItem



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/membership/MembershipListItem.tsx